import { FactAdder } from '@/new/components/fact-adder';
import { Icon } from '@/new/components/icon';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/new/components/shadcn/dialog';
import { DocIds } from '@/types';

interface AddFactDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  docs?: DocIds[];
  handleNewFactCreated: () => void;
  docId?: string;
}

export const AddFactDialog = ({ docId, isOpen, onOpenChange, docs, handleNewFactCreated }: AddFactDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle>
            <Icon className="lucide--plus-circle" />
            Add Fact
          </DialogTitle>
        </DialogHeader>

        <FactAdder docId={docId} docs={docs} handleNewFactCreated={handleNewFactCreated} />
      </DialogContent>
    </Dialog>
  );
};
